<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <banco-precos-data-table
          :items="bancosPrecosCalculos"
          :loading="loading"
          @recharge="getBancosPrecosCalculos()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getBancosPrecosCalculos())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import BancoPrecosService from '@/services/BancoPrecosCalculosService';
  import dayjs from 'dayjs';
  import tourMixins from '@/mixins/tourMixins';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      BancoPrecosDataTable: () => import('@/components/bancoPrecosCalculos/BancoPrecosDataTable')
    },
    mixins: [pusherMixins, tourMixins],

    data() {
      return {
        bancosPrecosCalculos: [],
        loading: false,
        processamentosExpirados: false,
        arrTour: [
          {
            element: '#btn-novo-calculo-bp',
            intro: 'Clicando neste botão você poderá criar novos cálculos de banco de preços.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#calculo-bp-search',
            intro: 'Neste campo você poderá pesquisar por cálculos de banco de preços já existentes.',
            scrollTo: 'tooltip',
            position: 'bottom'
          },
          {
            element: '#action-download-calculo-bp',
            intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de seu cálculo de banco de preços.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-edit-calculo-bp',
            intro: 'Clicando neste ícone você poderá editar seu cálculo de banco de preços.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-more-calculo-bp',
            intro:
              'Aqui você acessa outras opções para seu cálculo de banco de preços, como ver mais detalhes, executá-lo novamente, duplica-ló ou deletá-lo.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ]
      };
    },

    mounted() {
      this.getBancosPrecosCalculos();
      this.subscribe();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('reload-pag-calculo-banco', () => {
          this.getBancosPrecosCalculos();
        });
      },

      getBancosPrecosCalculos() {
        this.loading = true;
        this.bancosPrecosCalculos = [];

        BancoPrecosService.getBancosPrecosCalculos(this.processamentosExpirados)
          .then((response) => {
            response.data.bancosPrecosCalculos.forEach((element) => {
              let obj = {
                id: element.id,
                titulo: element.titulo,
                status: element.status,
                data_inicial: dayjs(element.data_inicial).format('DD/MM/YYYY'),
                data_final: dayjs(element.data_final).format('DD/MM/YYYY'),
                data_base: dayjs(element.data_base).format('DD/MM/YYYY'),
                data_processamento: element.data_processamento
                  ? dayjs(element.data_processamento).format('DD/MM/YYYY HH:mm')
                  : '-',
                usuario: element.usuario.nome,
                usuario_id: element.usuario.id
              };
              this.bancosPrecosCalculos.push(obj);
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar cálculo de banco de preços.', '', { position: 'topRight' });
          })
          .finally(() => {
            ((this.loading = false), this.iniciarTourPagina());
          });
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        let arrTourFormatted = this.bancosPrecosCalculos.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>